<payee-popup>
  <ng-template #payeePopupTitleTemplate>
    <h1>{{ "WORKFLOW_DIALOGS.MISSING_DATA_GENERAL.TITLE" | translate }}</h1>
  </ng-template>

  <ng-template #payeePopupDescriptionTemplate>
    <div class="description">
      {{ "WORKFLOW_DIALOGS.MISSING_DATA_GENERAL.DESCRIPTION" | translate }}
    </div>
  </ng-template>

  <payee-form-field
    width="max"
    height="taller"
  >
    <textarea
      payee-input
      [placeholder]="'WORKFLOW_DIALOGS.MISSING_DATA_GENERAL.PLACEHOLDER' | translate"
      [formControl]="message"
    ></textarea>
  </payee-form-field>

  <ng-template #payeePopupSubmitTemplate>
    <button
      payee-button
      color="blue"
      width="max"
      height="normal"
      [disabled]="loading"
      [loading]="loading"
      (click)="submit()"
    >
      {{ "WORKFLOW_DIALOGS.MISSING_DATA_GENERAL.SUBMIT" | translate }}
    </button>
  </ng-template>

  <ng-template #payeePopupCancelTemplate>
    <button
      payee-button
      mat-dialog-close
      color="white"
      width="max"
      height="normal"
      [isBorderButton]="true"
    >
      {{ "WORKFLOW_DIALOGS.MISSING_DATA_GENERAL.CANCEL" | translate }}
    </button>
  </ng-template>
</payee-popup>
